import { render, staticRenderFns } from "./EditRequest.vue?vue&type=template&id=65c9e893&scoped=true&"
import script from "./EditRequest.vue?vue&type=script&lang=js&"
export * from "./EditRequest.vue?vue&type=script&lang=js&"
import style0 from "./EditRequest.vue?vue&type=style&index=0&id=65c9e893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9e893",
  null
  
)

export default component.exports